var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v(" Hello "+_vm._s(_vm.user.firstName)+"! ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }